import { createRoutesFromElements, Route } from "react-router-dom";
import Zone from "./containers/Zone";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Register from "./pages/Register";

export default function BandwagonRoutes({ zoneId }: { zoneId: string }) {
  return createRoutesFromElements(
    <>
      <Route path="/login" element={<Login />} />,
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={<Zone zoneId={zoneId} />} index={true} />
    </>,
  );
}
